import { TAB_NAMES } from "@/organisms/Drawers/const"
import { makeLazyEvpTab } from "../makeLazyEvpTab"

const ExploitabilityTab = makeLazyEvpTab(TAB_NAMES.exploitValidation, () =>
  import("./ExploitabilityTabTriageDrawer").then((m) => ({
    default: m.ExploitabilityTabTriageDrawer
  }))
)

export default ExploitabilityTab
